// Reusable pill-shaped button
import React from "react";

interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
}

const AppButton: React.FC<AppButtonProps> = ({ variant = "primary", className = "", children, ...props }) => {
  const classes =
    variant === "primary"
      ? "bg-[#01545D] text-white font-bold py-3 px-12 rounded-full "
      : "border-2 border-[#01545D] text-[#01545D] bg-white font-bold py-3 px-12 rounded-full ";
  return (
    <button className={`${classes} ${className}`} {...props}>{children}</button>
  );
};

export default AppButton;
